<template>

  <v-select
      prepend-icon="fact_check"
      :items="items"
      v-model="item"
      :label="$t('cobrox.cobranza.labels.canalCobro')"
      :loading="loading"
      :error="hasInputErrors('canalCobro')"
      :error-messages="getInputErrors('canalCobro')"
      color="secondary"
      item-color="secondary"
      :readonly="readonly"
  ></v-select>

</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
import CanalCobroProvider from "@/modules/cobrox/providers/CanalCobroProvider";


export default {
  name: "CanalCobroCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {type: [String, Array]},
    readonly: {type:Boolean, default: false}
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    fetch() {
      this.loading = true
      CanalCobroProvider.fetchCanalCobro()
          .then(r => {
            this.items = r.data.fetchCanalCobro.map(e => e.nombre)
          })
          .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>

